import { CommonModule } from "@angular/common";
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnChanges,
} from "@angular/core";

import { EmpleadoFotoService } from "src/app/_core/providers/empleado-foto.service";
import {
	EmpleadoLike,
	empleadoEmail,
	empleadoInitials,
} from "src/app/_core/utils/empleado-display";

/**
 * Avatar circular de empleado: foto de EntraID (caché compartida) con fallback a
 * iniciales. Pieza mínima para opciones de buscadores y prefijos de campos `.ds`.
 */
@Component({
	selector: "app-empleado-avatar",
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<span class="eav" [class.sm]="size === 'sm'">
			<img *ngIf="fotoUrl; else inic" [src]="fotoUrl" alt="" />
			<ng-template #inic>{{ initials }}</ng-template>
		</span>
	`,
	styles: [
		`
			:host {
				display: inline-flex;
				flex: none;
			}
			.eav {
				flex: none;
				width: 34px;
				height: 34px;
				border-radius: 50%;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				background: var(--bg-2, #f0f0f2);
				color: var(--accent, #e30613);
				font: 700 12px/1 var(--sans);
				letter-spacing: 0.02em;
				overflow: hidden;
				user-select: none;
			}
			.eav.sm {
				width: 24px;
				height: 24px;
				font-size: 10px;
			}
			.eav img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				display: block;
			}
		`,
	],
})
export class EmpleadoAvatarComponent implements OnChanges {
	@Input() empleado: EmpleadoLike | null = null;
	@Input() size: "sm" | "md" = "md";

	initials = "?";
	fotoUrl: string | null = null;

	constructor(
		private readonly fotoService: EmpleadoFotoService,
		private readonly cdr: ChangeDetectorRef,
	) {}

	ngOnChanges(): void {
		this.initials = empleadoInitials(this.empleado);
		this.fotoUrl = null;
		const email = empleadoEmail(this.empleado);
		if (!email) {
			return;
		}
		this.fotoService.getFoto(email).subscribe((url) => {
			// Solo aplica si el empleado mostrado sigue siendo el mismo.
			if (empleadoEmail(this.empleado) === email) {
				this.fotoUrl = url;
				this.cdr.markForCheck();
			}
		});
	}
}
